import { render } from "./form.vue?vue&type=template&id=bf9f7b04&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=bf9f7b04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf9f7b04"

export default script